/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_Not_LinkedInputs */

const vi_shop_account_not_linked = /** @type {(inputs: Shop_Account_Not_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa liên kết`)
};

/**

* @param {Shop_Account_Not_LinkedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_not_linked = /** @type {((inputs?: Shop_Account_Not_LinkedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_Not_LinkedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_not_linked(inputs)
});